import { type FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

export const WitnessStatementInfoScreen: FC<FlowCustomComponentProps> = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          You'll need a witness statement
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          Because the will isn't self-proving, New York Surrogate's Court requires at least one
          witness to submit a signed, sworn statement (Form P-3).
        </p>
      </div>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip bg-white p-6">
        <p className="text-sm font-semibold mb-3">What happens next</p>
        <ul className="flex flex-col gap-3 text-sm text-secondary tracking-[-0.28px]">
          <li>
            <span className="font-semibold text-primary">Included in your packet:</span> We'll
            include the official witness affidavit (Form P-3) in your final form packet at the end
            of this flow.
          </li>
          <li>
            <span className="font-semibold text-primary">No action needed right now:</span> You
            don't need to contact witnesses today.
          </li>
          <li>
            <span className="font-semibold text-primary">How you'll use it:</span> Once you
            download your packet, you'll send this form to each available witness to sign in front
            of a Notary Public and return to you before you file.
          </li>
        </ul>
      </div>
    </div>
  );
};
